var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Input, ViewChild } from '@angular/core';
import { BatchEditVariableDto, CreateOrUpdateVariableDto } from '../../../../../shared/service-proxies/service-proxies';
import { finalize } from 'rxjs/operators';
import { ConfigureComponentBase } from '../../../../../shared/configure-component-base';
import { CreateOrEditVariableModalComponent } from './create-or-edit-modal/create-or-edit-variable-modal.component';
import { BatchImportVariableModalComponent } from './batch-import-modal/batch-import-variable-modal.component';
import { VariableGroupModalComponent } from './variable-group-modal/variable-group-modal.component';
import { BatchEditVariableModalComponent } from './batch-edit-modal/batch-edit-variable-modal.component';
import { VariableDataType } from './enums/variable-data-type';
import { VariableRwType } from './enums/variable-rw-type';
import { appModuleAnimation } from '../../../animations/routerTransition';
var VariableComponent = /** @class */ (function (_super) {
    __extends(VariableComponent, _super);
    function VariableComponent(injector, variableService, dataTypeService, dataSourceService, variableGroupService, modalService) {
        var _this = _super.call(this, injector) || this;
        _this.variableService = variableService;
        _this.dataTypeService = dataTypeService;
        _this.dataSourceService = dataSourceService;
        _this.variableGroupService = variableGroupService;
        _this.modalService = modalService;
        _this.variableName = '';
        _this.dataType = VariableDataType;
        _this.stateArray = [];
        _this.rwTypes = _this.getEnum(VariableRwType);
        _this.dataTypes = _this.getEnum(VariableDataType);
        return _this;
    }
    VariableComponent.prototype.ngOnInit = function () {
        var _this = this;
        abp.event.on('dataSource.add', function () { return _this.loadVariablesData(); });
        abp.event.on('dataSource.rename', function () { return _this.loadVariablesData(); });
        abp.event.on('dataSource.delete', function () { return _this.loadVariablesData(); });
        this.getDataSources();
        this.loadGroups();
    };
    VariableComponent.prototype.ngAfterViewInit = function () {
        var frozen = document.getElementsByClassName('ui-table-frozen-view')[0];
        frozen.style.cssFloat = 'right';
        var unfrozen = document.getElementsByClassName('ui-table-unfrozen-view')[0];
        unfrozen.style.position = 'initial';
    };
    VariableComponent.prototype.ngAfterViewChecked = function () {
        this.setFrozenColumnHeight();
    };
    VariableComponent.prototype.ngOnDestroy = function () {
        abp.event.off('dataSource.add', null);
        abp.event.off('dataSource.rename', null);
        abp.event.off('dataSource.delete', null);
    };
    VariableComponent.prototype.createVariable = function () {
        var _this = this;
        var createOrEditVariableDto = new CreateOrUpdateVariableDto();
        createOrEditVariableDto.configureId = this.configureId;
        var modalRef = this.modalService.show(CreateOrEditVariableModalComponent, {
            initialState: {
                configureId: this.configureId,
                createOrUpdateVariableDto: createOrEditVariableDto
            },
            backdrop: 'static'
        });
        modalRef.content.variableCreated.subscribe(function () {
            _this.loadVariablesData();
        });
    };
    VariableComponent.prototype.loadGroups = function () {
        var _this = this;
        this.variableGroupService.getVariableGroups(this.configureId)
            .subscribe(function (result) {
            _this.groupList = result;
        });
    };
    VariableComponent.prototype.showBatchImportModal = function () {
        var _this = this;
        var modalRef = this.modalService.show(BatchImportVariableModalComponent, {
            initialState: {
                configureId: this.configureId
            },
            backdrop: 'static',
            class: 'batch-import-variable-modal'
        });
        modalRef.content.variableImportEvent.subscribe(function () {
            _this.loadVariablesData();
        });
    };
    VariableComponent.prototype.getDataSources = function () {
        var _this = this;
        this.dataSourceService.getDataSourceForDataConfigByConfigureId(this.configureId)
            .subscribe(function (result) { return _this.dataSources = result; });
    };
    VariableComponent.prototype.loadVariablesData = function () {
        this.loadGroups();
        this.getDataSources();
        this.loadVariables();
    };
    VariableComponent.prototype.loadVariablesAndGroupOnCurrentPage = function () {
        this.loadGroups();
        this.loadVariables(this.lazyLoadEvent);
    };
    VariableComponent.prototype.loadVariableAndGroup = function (deletedIds) {
        if (this.selectedVariables && deletedIds.length > 0) {
            this.selectedVariables = this.selectedVariables.filter(function (x) { return deletedIds.findIndex(function (id) { return id === x.id; }) === -1; });
        }
        this.loadGroups();
        this.loadVariables();
    };
    VariableComponent.prototype.loadVariablesDataOnCurrentPage = function () {
        this.getDataSources();
        this.loadVariables(this.lazyLoadEvent);
    };
    VariableComponent.prototype.loadVariables = function (event) {
        var _this = this;
        this.lazyLoadEvent = event;
        if (this.primengTableHelper.shouldResetPaging(event)) {
            this.paginator.changePage(0);
            return;
        }
        if (!this.selectedGroupId) {
            this.selectedGroupId = undefined;
        }
        if (!this.selectedDataSourceId) {
            this.selectedDataSourceId = undefined;
        }
        if (!this.selectedRwType) {
            this.selectedRwType = undefined;
        }
        if (!this.selectedDataType) {
            this.selectedDataType = undefined;
        }
        this.primengTableHelper.showDelayLoadingIndicator();
        this.variableService.getVariables(this.configureId, this.selectedDataSourceId, this.selectedGroupId, this.selectedDataType && +this.selectedDataType, this.selectedRwType && +this.selectedRwType, this.variableName, this.primengTableHelper.getSorting(this.dataTable), this.primengTableHelper.getMaxResultCount(this.paginator, event), this.primengTableHelper.getSkipCount(this.paginator, event)).pipe(finalize(function () {
            _this.primengTableHelper.requestCompleted = true;
            _this.primengTableHelper.hideLoadingIndicator();
        })).subscribe(function (result) {
            _this.primengTableHelper.totalRecordsCount = result.totalCount;
            _this.primengTableHelper.records = result.items;
            if (_this.lazyLoadEvent && result.totalCount && (!result.items || result.items.length === 0)) {
                var jumpToPage = ~~((result.totalCount - 1) / _this.paginator.rows);
                _this.paginator.changePage(jumpToPage);
            }
            setTimeout(function () {
                _this.handleHeaderCheckboxState(result.items);
            });
        });
    };
    VariableComponent.prototype.handleHeaderCheckboxState = function (items) {
        var _this = this;
        if (!items || items.length === 0 || !this.selectedVariables || this.selectedVariables.length === 0) {
            this.tableHeaderCheckbox.checked = false;
            return;
        }
        items.forEach(function (x) {
            if (_this.selectedVariables.findIndex(function (i) { return +i.id === +x.id; }) === -1) {
                _this.tableHeaderCheckbox.checked = false;
                return;
            }
        });
    };
    VariableComponent.prototype.emptyConditions = function () {
        this.variableName = '';
        this.selectedDataSourceId = null;
        this.loadVariables();
    };
    VariableComponent.prototype.editVariable = function (id) {
        var _this = this;
        var updateVariableDto = new CreateOrUpdateVariableDto();
        updateVariableDto.id = id;
        updateVariableDto.configureId = this.configureId;
        var modalRef = this.modalService.show(CreateOrEditVariableModalComponent, {
            initialState: {
                configureId: this.configureId,
                createOrUpdateVariableDto: updateVariableDto
            },
            backdrop: 'static'
        });
        modalRef.content.variableEdited.subscribe(function () {
            _this.loadVariablesDataOnCurrentPage();
        });
    };
    VariableComponent.prototype.deleteVariable = function (variable) {
        var _this = this;
        this.message.confirm(this.lc('DeletingVariableWarningMessage', variable.name), this.l('AreYouSure'), function (isConfirmed) {
            if (isConfirmed) {
                _this.variableService.deleteVariable(variable.id)
                    .subscribe(function () {
                    if (_this.selectedVariables) {
                        _this.selectedVariables = _this.selectedVariables.filter(function (x) { return x.id !== variable.id; });
                    }
                    _this.loadVariables(_this.lazyLoadEvent);
                    _this.notify.success(_this.l('SuccessfullyDeleted'));
                });
            }
        });
    };
    VariableComponent.prototype.batchDeleteVariables = function () {
        var _this = this;
        var preDeleteVariableIds = this.selectedVariables.map(function (v) { return v.id; });
        this.message.confirm(this.selectedVariables.length === 1
            ? this.lc('DeletingVariableWarningMessage', this.selectedVariables[0].name)
            : this.lc('DeletingVariablesWarningMessage', this.selectedVariables.length), this.l('AreYouSure'), function (isConfirmed) {
            if (isConfirmed) {
                _this.variableService.batchDeleteVariables({
                    variableIds: preDeleteVariableIds
                })
                    .subscribe(function () {
                    _this.selectedVariables = [];
                    _this.loadVariables();
                    _this.notify.success(_this.l('SuccessfullyDeleted'));
                });
            }
        });
    };
    VariableComponent.prototype.batchEditVariables = function () {
        var _this = this;
        var variableIds = this.selectedVariables.map(function (x) { return x.id; });
        var batchEditVariableDto = new BatchEditVariableDto();
        batchEditVariableDto.configureId = +this.configureId;
        batchEditVariableDto.variableIds = variableIds;
        var modalRef = this.modalService.show(BatchEditVariableModalComponent, {
            initialState: {
                configureId: this.configureId,
                batchEditVariableDto: batchEditVariableDto
            },
            backdrop: 'static'
        });
        modalRef.content.batchEditedEvent.subscribe(function () {
            _this.loadVariablesDataOnCurrentPage();
        });
    };
    VariableComponent.prototype.formatDataType = function (dataType, bitIndexEnabled) {
        var _this = this;
        return this.dataTypeService.formatDataType(dataType, bitIndexEnabled, function (key) {
            var args = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args[_i - 1] = arguments[_i];
            }
            return _this.lc.apply(_this, [key].concat(args));
        });
    };
    VariableComponent.prototype.showVariableGroupModal = function () {
        var _this = this;
        var modalRef = this.modalService.show(VariableGroupModalComponent, {
            initialState: {
                configureId: this.configureId
            }
        });
        modalRef.content.groupSavedEvent.subscribe(function () {
            _this.loadGroups();
        });
        modalRef.content.groupEditedEvent.subscribe(function () {
            _this.loadVariablesAndGroupOnCurrentPage();
        });
        modalRef.content.groupDeletedEvent.subscribe(function (result) {
            _this.loadVariableAndGroup(result);
        });
    };
    VariableComponent.prototype.loadVariablesAndClearSelectedItems = function () {
        this.selectedVariables = [];
        this.loadVariables();
    };
    VariableComponent.prototype.getLabelString = function (labelText) {
        if (!labelText) {
            return '';
        }
        var stateArray = JSON.parse(labelText);
        if (!stateArray || stateArray.length === 0) {
            return '';
        }
        return stateArray.map(function (x) {
            return x.key + ": " + (x.value || x.key);
        }).join(', ');
    };
    VariableComponent.prototype.getConfigureVariableDataType = function (dataTypeStr) {
        return this.lc("ConfigureVariableDataType." + dataTypeStr);
    };
    VariableComponent.prototype.getEnum = function (enumType) {
        var myEnum = [];
        var objectEnum = Object.keys(enumType);
        var values = objectEnum.slice(0, objectEnum.length / 2);
        var keys = objectEnum.slice(objectEnum.length / 2);
        for (var i = 0; i < objectEnum.length / 2; i++) {
            myEnum.push({ key: keys[i], value: +values[i] });
        }
        return myEnum;
    };
    __decorate([
        ViewChild('tableHeaderCheckbox', { static: false })
    ], VariableComponent.prototype, "tableHeaderCheckbox", void 0);
    __decorate([
        Input()
    ], VariableComponent.prototype, "configureId", void 0);
    __decorate([
        ViewChild('dataTable', { static: true })
    ], VariableComponent.prototype, "dataTable", void 0);
    __decorate([
        ViewChild('paginator', { static: false })
    ], VariableComponent.prototype, "paginator", void 0);
    VariableComponent = __decorate([
        Component({
            selector: 'variable',
            template: "<div class=\"portlet-input design-portlet-input\"> <div class=\"variable-operation row\"> <div class=\"search-condition col-lg-8\"> <div class=\"operation-input-select col-lg-2\"> <ng-select name=\"dataTypeSelect\" [items]=\"dataTypes\" bindLabel=\"key\" bindValue=\"value\" [searchable]=\"false\" [placeholder]=\"lc('AllDataType')\" [(ngModel)]=\"selectedDataType\" [clearable]=\"true\" (change)=\"loadVariablesAndClearSelectedItems()\" [notFoundText]=\"l('NoData')\"> <ng-template ng-option-tmp ng-label-tmp let-item=\"item\"> {{getConfigureVariableDataType(item.key)}} </ng-template> </ng-select> </div> <div class=\"operation-input-select col-lg-2\"> <ng-select name=\"groupSelect\" [items]=\"groupList\" bindLabel=\"name\" bindValue=\"id\" [searchable]=\"true\" [placeholder]=\"lc('AllGroup')\" [(ngModel)]=\"selectedGroupId\" [clearable]=\"true\" (change)=\"loadVariablesAndClearSelectedItems()\" [notFoundText]=\"l('NoData')\"> <ng-template ng-option-tmp ng-label-tmp let-item=\"item\"> {{item.name}} </ng-template> </ng-select> </div> <div class=\"operation-input-select col-lg-2\"> <ng-select name=\"dataSourceSelect\" [items]=\"dataSources\" bindLabel=\"displayName\" bindValue=\"id\" [searchable]=\"false\" [placeholder]=\"lc('AllDataSource')\" [(ngModel)]=\"selectedDataSourceId\" [clearable]=\"true\" (change)=\"loadVariablesAndClearSelectedItems()\" [notFoundText]=\"l('NoData')\"> <ng-template ng-option-tmp ng-label-tmp let-item=\"item\"> {{item.displayName}} </ng-template> </ng-select> </div> <div class=\"operation-input-select col-lg-2\"> <ng-select name=\"rwTypeSelect\" [items]=\"rwTypes\" bindLabel=\"key\" bindValue=\"value\" [searchable]=\"false\" [placeholder]=\"lc('AllReadWrite')\" [(ngModel)]=\"selectedRwType\" [clearable]=\"true\" (change)=\"loadVariablesAndClearSelectedItems()\" [notFoundText]=\"l('NoData')\"> <ng-template ng-option-tmp ng-label-tmp let-item=\"item\"> {{lc(item.key)}} </ng-template> </ng-select> </div> </div> </div> <div class=\"variable-operation row\"> <div class=\"operation-button col-lg-6\"> <button class=\"fe-btn fe-btn-default fe-btn-save\" (click)=\"createVariable()\">{{l('Add')}}</button> <button class=\"fe-btn fe-btn-default fe-btn-save\" (click)=\"showBatchImportModal()\">{{lc('BatchImport')}}</button> <button class=\"fe-btn fe-btn-default btn-batch-delete\" [disabled]=\"!selectedVariables || selectedVariables.length == 0\" (click)=\"batchEditVariables()\">{{lc('BatchEdit')}}</button> <button class=\"fe-btn fe-btn-default btn-batch-delete\" [disabled]=\"!selectedVariables || selectedVariables.length == 0\" (click)=\"batchDeleteVariables()\">{{lc('BatchDelete')}}</button> <button class=\"fe-btn fe-btn-default fe-btn-normal\" (click)=\"showVariableGroupModal()\">{{lc('VariableGroupManage')}}</button> </div> <div class=\"operation-input col-lg-6 clearfix\"> <div class=\"operation-input-search col-lg-4\"> <input placeholder='{{lc(\"SearchVariableOrMonitor\")}}' type=\"text\" name=\"variableName\" [(ngModel)]=\"variableName\" (change)=\"loadVariablesAndClearSelectedItems()\"> <i class=\"fcloud-search\" (click)=\"loadVariablesAndClearSelectedItems()\"></i> </div> </div> </div> </div> <div class=\"primeng-datatable-container variable-component-table\" [busyIf]=\"primengTableHelper.isLoading\"> <p-table #dataTable (onLazyLoad)=\"loadVariables($event)\" [value]=\"primengTableHelper.records\" rows=\"{{primengTableHelper.defaultRecordsCountPerPage}}\" [paginator]=\"false\" [lazy]=\"true\" [(selection)]=\"selectedVariables\" selectionMode=\"multiple\" dataKey=\"id\" [scrollable]=\"true\" ScrollWidth=\"100%\" responsive=\"primengTableHelper.isResponsive\" frozenWidth=\"200px\"> <ng-template pTemplate=\"frozenheader\"> <tr class=\"p-table-change-frozen-column-height designer-actions-style\"> <th class=\"last-th\"> {{l('Actions')}} <span class=\"fa fa-cog fa-fw\"></span> </th> </tr> </ng-template> <ng-template pTemplate=\"frozenbody\" let-record> <tr class=\"p-table-change-frozen-column-height\" [pSelectableRow]=\"record\"> <td> <div class=\"table-control-right\"> <ul> <li> <a (click)=\"editVariable(record.id)\">{{l('Edit')}}</a> </li> <li> <a (click)=\"deleteVariable(record)\">{{l('Delete')}}</a> </li> </ul> </div> </td> </tr> </ng-template> <ng-template pTemplate=\"header\"> <tr class=\"p-table-get-unfrozen-column-height\"> <th class=\"checkbox\" style=\"width: 50px;\"> <p-tableHeaderCheckbox #tableHeaderCheckbox></p-tableHeaderCheckbox> </th> <th class=\"col-xs-1 col-md-1\"> {{lc('ConfigureVariableName')}} </th> <th class=\"col-xs-1 col-md-1\"> {{lc('Unit')}} </th> <th class=\"col-xs-1 col-md-1\"> {{lc('DataSourceName')}} </th> <th class=\"col-xs-1 col-md-1\"> {{lc('VariableGroup')}} </th> <th class=\"col-xs-1 col-md-1\"> {{lc('DataType')}} </th> <th class=\"col-xs-1 col-md-1\"> {{lc('MinValue')}} </th> <th class=\"col-xs-1 col-md-1\"> {{lc('MaxValue')}} </th> <th class=\"col-xs-1 col-md-1\"> {{lc('CharCount')}} </th> <th class=\"col-xs-1 col-md-1\"> {{lc('StateDescription')}} </th> <th class=\"col-xs-1 col-md-1\"> {{lc('AccessRights')}} </th> <th class=\"col-xs-1 col-md-1\"> {{lc('RefVariableName')}} </th> <th class=\"col-xs-1 col-md-1\"> {{lc('VariableDevice')}} </th> <th class=\"col-xs-1 col-md-1\"> {{lc('ConfigureVariableStationNo')}} </th> <th class=\"col-xs-1 col-md-1\"> {{lc('VariableDataType')}} </th> <th class=\"col-xs-1 col-md-1\"> {{lc('VariableAddress')}} </th> </tr> </ng-template> <ng-template pTemplate=\"body\" let-record> <tr class=\"p-table-get-unfrozen-column-height\" [pSelectableRow]=\"record\"> <td class=\"checkbox\"> <p-tableCheckbox [value]=\"record\"></p-tableCheckbox> </td> <td> {{record.name}} </td> <td> {{record.dataType === dataType.Int32 || record.dataType === dataType.Float ? record.unit : '-'}} </td> <td> {{record.configureDataSourceName}} </td> <td> {{record.groupName}} </td> <td> {{getConfigureVariableDataType(record.dataTypeStr)}} </td> <td> {{record.dataType === dataType.Int32 || record.dataType === dataType.Float ? record.minValue : '-'}} </td> <td> {{record.dataType === dataType.Int32 || record.dataType === dataType.Float ? record.maxValue : '-'}} </td> <td> {{record.dataType === dataType.String ? record.charCount : '-'}} </td> <td> {{record.dataType === dataType.Bool ? getLabelString(record.labelText) : '-'}} </td> <td> {{lc(record.variableRwTypeStr)}} </td> <td> {{record.refFBoxVariableDto?.name}} </td> <td> {{record.refFBoxVariableDto?.devAlias}} </td> <td> {{record.refFBoxVariableDto?.stationNo}} </td> <td> {{record.refFBoxVariableDto ? formatDataType(record.refFBoxVariableDto.dataType, record.refFBoxVariableDto.bitIndexEnabled) : ''}} </td> <td> {{record.refFBoxVariableDto?.addressDescription}} </td> </tr> </ng-template> </p-table> <div class=\"primeng-no-data\" *ngIf=\"primengTableHelper.totalRecordsCount == 0\"> {{l('NoData')}} </div> <div class=\"primeng-paging-container\"> <p-paginator #paginator [rows]=\"primengTableHelper.defaultRecordsCountPerPage\" (onPageChange)=\"loadVariables($event)\" [totalRecords]=\"primengTableHelper.totalRecordsCount\" [rowsPerPageOptions]=\"primengTableHelper.predefinedRecordsCountPerPage\"> </p-paginator> <span class=\"total-records-count\"> {{l('TotalRecordsCount', primengTableHelper.totalRecordsCount)}} </span> </div> </div> ",
            styles: [".design-portlet-input { .last-th { text-align: right !important; span { padding-right: 0; float: right; } .fa-fw{ float: none !important; } } .ng-select-container { height: 34px !important; } .checkbox { width: 50px; } .empty-box { height: 0; padding: 0; margin: 0; font-size: 0 } .variable-operation { .operation-button { button:not(:last-child) { margin-right: 12px; margin-bottom: 12px; } } // .search-condition { //     div { //     } // } select, input[type=\"text\"] { height: 34px; line-height: 34px; border: 1px solid #C4C6CF; color: rgba(0, 0, 0, 0.6); } input::-webkit-input-placeholder { color: rgba(0, 0, 0, 0.6); } input::-moz-placeholder { /* Mozilla Firefox 19+ */ color: rgba(0, 0, 0, 0.6); } input:-moz-placeholder { /* Mozilla Firefox 4 to 18 */ color: rgba(0, 0, 0, 0.6); } input:-ms-input-placeholder { /* Internet Explorer 10-11 */ color: rgba(0, 0, 0, 0.6); } .ng-select.ng-select-single .ng-select-container .ng-value-container .ng-input { top: 0 !important; } .operation-input-select { padding: 0; float: left; margin-bottom: 12px; select { width: 100%; } } .operation-input { font-size: 0; } .operation-input>div { float: right; margin-bottom: 12px; font-size: 14px; } .operation-input-search { position: relative; padding: 0; input { width: 100%; padding-left: 10px; padding-right: 34px; } .fcloud-search { position: absolute; right: 10px; top: 10px; cursor: pointer; } } } input, select { color: rgba(0, 0, 0, 0.6); } option { color: rgba(0, 0, 0, 0.6) } .operation { text-align: right !important; a { color: #3695FF !important; cursor: pointer; } a:first-child { margin-right: 10px; } } .fe-btn.fe-btn-default.btn-batch-delete { color: #000; background-color: #FFF; border: 1px solid #C4C6CF; } .fe-btn.fe-btn-default.fe-btn-normal { border: 1px solid #b5c2ca; background-color: white; } .fe-btn.fe-btn-default.btn-batch-delete:disabled { color: #7F939F; border: 1px solid #b5c2ca; } @media (min-width: 992px) { .variable-operation .operation-input-select select { margin-right: 12px; width: calc(100% - 12px); } } ng-select { margin-right: 12px; } .operation-input-select ::ng-deep .ng-select-container { height: 34px !important; border: 1px solid #C4C6CF; padding-top: 8px; } .p-table-get-unfrozen-column-height th:not(:first-child) { width: 150px; } .p-table-get-unfrozen-column-height td:not(:first-child) { width: 150px; } } .variable-component-table{ .checkbox { width: 50px !important; } } .designer-actions-style{ .last-th{ span{ float: right; } } .fa-fw{ float: none !important; } }"],
            animations: [appModuleAnimation()]
        })
    ], VariableComponent);
    return VariableComponent;
}(ConfigureComponentBase));
export { VariableComponent };
